import { jsx as _jsx } from "react/jsx-runtime";
import { PaginationView } from './pagination';
export var PaginationContainer = function (_a) {
    var pageSize = _a.pageSize, totalItems = _a.totalItems, pageIndex = _a.pageIndex, setPageIndex = _a.setPageIndex;
    var totalPages = Math.ceil(totalItems / pageSize);
    var firstShownResult = pageIndex * pageSize + 1;
    var lastShownResult = Math.min((pageIndex + 1) * pageSize, totalItems);
    if (totalPages <= 1) {
        return null;
    }
    return (_jsx(PaginationView, { totalPages: totalPages, currentPage: pageIndex, firstShownResult: firstShownResult, lastShownResult: lastShownResult, totalResults: totalItems, onPageChange: setPageIndex }));
};
